import { render, staticRenderFns } from "./checkboxOn.vue?vue&type=template&id=5fa2b7ff&scoped=true&"
var script = {}
import style0 from "./checkboxOn.vue?vue&type=style&index=0&id=5fa2b7ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa2b7ff",
  null
  
)

export default component.exports